import NumberFormatInput from './number-format-input';

export default NumberFormatInput;